export enum ViewOptionsEnum {
    LISTVIEW,
    TILEVIEW
}
